export default function formatCurrency(num) {
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}